<div class="row p-3 w-100 mx-auto">
  <div class="align-items-center col-12 d-flex">
    <h1 mat-dialog-title class="ms-auto foxpost-title text-center">
      {{ data.title }}
    </h1>

    <button mat-icon-button mat-dialog-close class="ms-auto">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider class="my-2"></mat-divider>
  <div class="col-12" mat-dialog-content>
    <iframe
      [src]="safeUrl"
      width="100%"
      style="min-height: 450px; height: auto; border: 0"
      allowfullscreen
    ></iframe>
  </div>
</div>
